import { MessageCircle } from "lucide-react";

export const WhatsAppButton = ({ whatsapp, testId = "whatsapp-button", fallback }) => {
  if (!whatsapp) {
    return fallback ? <p className="text-xs text-stone-500" data-testid={`${testId}-missing`}>{fallback}</p> : null;
  }
  return (
    <a
      href={whatsapp.link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#1F8A4C] px-4 py-2.5 text-sm font-semibold text-white transition-[background-color,transform] duration-150 hover:bg-[#18733f] active:scale-[0.98]"
    >
      <MessageCircle className="h-4 w-4" />
      Chat via WhatsApp
      <span className="font-normal opacity-80">· {whatsapp.number}</span>
    </a>
  );
};
